import type { ExperienceChild } from '@/features/experiences/types';
import { ExperienceChildConfigKind } from '@/types/gql.generated';

/**
 * The view a planner should open on: the one an owner or editor marked as the
 * default, falling back to the first interactive child, then to the first child.
 *
 * The author's choice is resolved against `children` rather than trusted, so an
 * id whose view has since been removed degrades to the derived default instead
 * of rendering nothing.
 */
export const getDefaultChild = (
  children: ExperienceChild[],
  defaultChildExperienceId?: string | null
): ExperienceChild | undefined =>
  children.find((child) => child.id === defaultChildExperienceId) ??
  children.find(
    (child) => child.kind === ExperienceChildConfigKind.Interactive
  ) ??
  children[0];
